import { useQuery } from '@tanstack/react-query';
import { getProposalDiscussions, getTeamMeasures, getWorkEnvironmentMeasures } from '../../api/workEnvironmentQueries';

export const WorkEnvironmentMeasuresQueryKey = 'WORK_ENVIRONMENT_MEASURES';
export const TeamMeasuresQueryKey = 'WORK_ENVIRONMENT_TEAM_MEASURES';
export const ProposalDiscussionsQueryKey = 'WORK_ENVIRONMENT_PROPOSAL_DISCUSSIONS';

export const useWorkEnvironmentMeasuresQuery = (surveyId: number, language: string) =>
  useQuery({
    queryKey: [WorkEnvironmentMeasuresQueryKey, surveyId, language],
    queryFn: () => getWorkEnvironmentMeasures(surveyId, language),
  });

/** A survey in the old flow has no measures here, so the page falls back to the old one */
export const useTeamMeasuresQuery = (uuid: string | undefined, language: string, token: string) =>
  useQuery({
    queryKey: [TeamMeasuresQueryKey, uuid, language],
    queryFn: () => getTeamMeasures(uuid!, language, token),
    enabled: Boolean(uuid),
    retry: false,
  });

export const useProposalDiscussionsQuery = (surveyId: number) =>
  useQuery({
    queryKey: [ProposalDiscussionsQueryKey, surveyId],
    queryFn: () => getProposalDiscussions(surveyId),
  });
